import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { generatePath, useParams } from 'react-router';

import { useConfig } from '@xingternal/hops';

import { Head } from '@/components/_common';
import { JobsDirectory } from '@/components/jobs-directory';
import { NavigationBackButton } from '@/components/navigation-back-button';
import { routes } from '@/config';
import { LandingHero } from '@/domain/marketing/landing-hero';
import { ExternalSearchBox } from '@/domain/search/components';
import { useBreakpoints } from '@/hooks';

type Params = {
  letter: string;
};

export const JobsDirectoryPage: React.FC = () => {
  const { externalUrl } = useConfig();
  const { formatMessage } = useIntl();
  const { isMobile } = useBreakpoints();
  const { letter } = useParams<Params>();

  const title = formatMessage({ id: 'XJM_META_TITLE_DIRECTORY_LETTER' }, { letter: letter.toUpperCase() });
  const description = formatMessage({ id: 'XJM_META_DESCRIPTION_DIRECTORY_LETTER' }, { letter: letter });

  const path = generatePath(routes.jobsDirectory, {
    letter: letter.toLocaleLowerCase(),
  });

  const canonicalUrl = `${externalUrl}${path}`;

  return (
    <>
      <Head title={title} description={description} canonicalUrl={canonicalUrl} robots="noodp" />
      {!isMobile && <NavigationBackButton title={<FormattedMessage id="JOBS_POSTING_NAVIGATION_HOME" />} to="/" />}
      <LandingHero />
      <ExternalSearchBox />
      <JobsDirectory letter={letter} />
    </>
  );
};
